import { CalcItemSpecs, ParsedSku } from '../types';

/**
 * SKU Utility
 */
export abstract class SKU {
  static parse(sku: string): ParsedSku {
    if (!sku || !sku.startsWith('PRD:')) throw new Error('Invalid sku provided');

    const skuSpecs = sku.split('-');
    const code = skuSpecs[0].split(':')[1];
    skuSpecs.shift();

    const specs = skuSpecs.map((spec) => {
      const [code, value] = spec.split(':');
      if (!code || !value) {
        console.debug(`Invalid SKU spec`, { specCode: code, specValueCode: value });
        console.warn('Error while parsing the SKU specs');
      }
      return { code, value };
    });
    return { code, specs };
  }

  static create(code: string, specs: CalcItemSpecs) {
    if (!specs || Object.keys(specs).length === 0) return `PRD:${code}`;
    return `PRD:${code}-${Object.keys(specs)
      .map((key) => `${key}:${specs[key].valueCode}`)
      .join('-')}`;
  }
}
